import { SelectList, ListItem, Button, Icons } from 'construct-ui';
import codeMasterModel from '../../../models/common/code-master.model';
import loginModel from '../../../models/login.model';

export default function MasterConfigurationDropdownView() {
  // let _attrs;
  // let selectedCode = "";
  // let selectedName = "";
  let items = [];
  let code = "";
  let selectedItem = { code: "", name: "" };

  let handleSelect = (item) => {}

  let getValuesByCode = (code) => {
    items = [];
    codeMasterModel.getByCategory(
      (result) => {
        items = result;
      },
      (error) => {
        items = [];
        // log.e({error: error, params:{category: _attrs.category, countryCode: _countryCode }});
      },
      { category: code, countryCode: loginModel.credentials.country }
    );
  }
  function renderItem(item) {
    return m(ListItem, {
      label: item.name,//.toLocaleString(),
      selected: selectedItem.code == item.code,
    })

  }

  function itemPredicate(query, item) {
    var xxx = item.name.toLowerCase().includes(query.toLowerCase());
    return xxx;
  }

  function handleSelectedItem(item) {
    selectedItem.code = item.code;
    selectedItem.name = item.name;
    handleSelect(selectedItem);
  }

  function renderLabel() {
    if (selectedItem.name && selectedItem.name != "") {
      return selectedItem.name;
    }
    else {
      return 'Choose...';
    }
  }

  return {
    oninit: ({ attrs }) => {
      // _attrs = attrs;
      if (attrs.handleSelect) {
        handleSelect = attrs.handleSelect;
      }
      if (attrs.code) {
        code = attrs.code;
        getValuesByCode(code);
      }
    },
    onupdate: ({ attrs }) => {
      selectedItem = attrs.selectedItem;
    },
    view: ({ attrs }) => {
      selectedItem = attrs.selectedItem;
      return m(SelectList, {
        closeOnSelect: true,
        items: items,
        itemRender: renderItem,
        itemPredicate: itemPredicate,
        onSelect: handleSelectedItem,
        popoverAttrs: {
          hasArrow: false
        },
        trigger: m(Button, {
          align: 'left',
          disabled: attrs.disabled,
          compact: true,
          class: 'select-list',
          fluid: true,
          iconRight: Icons.CHEVRON_DOWN,
          outlined: true,
          label: renderLabel(),
        })
      })
    }
  };
}
